module.exports = new __parcel__URL__("pipeline2.224c044d.jpg").toString();